import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCheckbox,{ref:"filterToDoc",attrs:{"readonly":_vm.disableElements,"label":"Filter Doctors by Specialization"},on:{"change":function($event){return _vm.handleChangeToFilterDoc($event)}},model:{value:(_vm.filterDoc),callback:function ($$v) {_vm.filterDoc=$$v},expression:"filterDoc"}})
}
var staticRenderFns = []

export { render, staticRenderFns }